import { render, staticRenderFns } from "./GrupoFamiliarBeneficiario.vue?vue&type=template&id=7a88f24d"
import script from "./GrupoFamiliarBeneficiario.vue?vue&type=script&lang=js"
export * from "./GrupoFamiliarBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./GrupoFamiliarBeneficiario.vue?vue&type=style&index=0&id=7a88f24d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports